// "From the Field" — practical lessons drawn from real cybersecurity
// implementation work. Themes only. No client names, project names,
// employer-sensitive information, testimonials or invented metrics.
export const FIELD_NOTES = [
  {
    id: 'pam-identity',
    number: '01',
    label: 'From the Field',
    title: "PAM Doesn't Fix Identity Problems. It Exposes Them.",
    body: 'Privileged-access programs can quickly surface stale accounts, unclear ownership, inconsistent permissions and poorly structured identity groups that existed long before the PAM deployment.',
    lesson: 'Identity hygiene and accountability come before automation.',
    service: 'Identity & Access Security',
    slug: 'identity-access-security',
  },
  {
    id: 'tools-arent-security',
    number: '02',
    label: 'Practical Lesson',
    title: "Security Tools Don't Create Security by Themselves.",
    body: 'DLP and FIM become difficult to operate when sensitive data, business processes and ownership aren\u2019t understood first.',
    lesson: 'Effective controls reflect how the business actually operates.',
    service: 'Data Protection & Backup',
    slug: 'data-protection-backup',
  },
  {
    id: 'vuln-visibility',
    number: '03',
    label: 'From the Field',
    title: "A Vulnerability Scanner Can't Protect What It Can't See.",
    body: 'Vulnerability management starts with asset visibility. Cloud, on-premises and hybrid environments can create blind spots when discovery, scanning and remediation are disconnected.',
    lesson: 'Visibility comes before prioritization.',
    service: 'Vulnerability Management',
    slug: 'vulnerability-management',
  },
  {
    id: 'non-ad-privilege',
    number: '04',
    label: 'Practical Lesson',
    title: 'Not Every Privileged System Lives in Active Directory.',
    body: 'Non-domain Linux and Windows systems can contain privileged accounts, service accounts, local administrators, root/sudo access and SSH keys that still require control and accountability.',
    lesson: 'Exceptions should not become blind spots.',
    service: 'Identity & Access Security',
    slug: 'identity-access-security',
  },
  {
    id: 'after-access',
    number: '05',
    label: 'From the Field',
    title: 'Privileged Access Is About What Happens After Access Is Granted.',
    body: 'Session visibility, approval workflows and the ability to intervene during privileged activity matter when the impact of misuse can be immediate.',
    lesson: 'Access control is only part of privileged security.',
    service: 'Identity & Access Security',
    slug: 'identity-access-security',
  },
  {
    id: 'ownership',
    number: '06',
    label: 'Practical Lesson',
    title: 'Security Controls Need Ownership, Not Just Configuration.',
    body: 'A control becomes meaningful when someone understands why it exists, who owns it, how it is monitored and what happens when something goes wrong.',
    lesson: 'Security is ultimately an accountability discipline.',
    service: 'Security Assessment',
    slug: 'security-assessment',
  },
];
